// extracted by mini-css-extract-plugin
export default {"notes":"Notes_notes__KIiao","notes-list-container__place-holder":"Notes_notes-list-container__place-holder__BtlHl"};